<template>
<div>
  <div class="section">
    <h4 class="title">{{ $t('login.history.label') }}</h4>
    <p> {{ $t('login.history.describe') }}</p>
  </div>
  <div class="section">
    <div class="alert alert-danger" v-if="this.errorMessage" v-html="$t(this.errorMessage)"></div>
    <div class="table-responsive">
      <table class="table table-bordered text-center table-hover table-striped table-font-sm border-right-1">
        <thead>
        <tr>
          <th class="text-center w-16">{{ $t('login.history.table.login.time') }}</th>
          <th class="text-center w-16">{{ $t('login.history.table.os') }}</th>
          <th class="text-center w-16">{{ $t('login.history.table.browser.or.app') }}</th>
          <th class="text-center w-16">{{ $t('login.history.table.authentication.method') }}</th>
          <th class="text-center w-24">{{ $t('login.history.table.ip.address') }}</th>
          <th class="text-center w-12">{{ $t('login.history.table.status') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(record, index) in viewData" v-bind:key="index">
          <td>{{ record.loginTime }}</td>
          <td>{{ record.osType }}</td>
          <td>{{ record.browserApp }}</td>
          <td>{{ record.authMethod }}</td>
          <td>{{ record.ipAddress }}</td>
          <td>{{ record.status }}</td>
        </tr>
        <tr>
          <td colspan="11" v-if="viewData == null || viewData.length === 0" class="nodata">
            {{ $t('nodata.found') }}
          </td>
        </tr>
        </tbody>

      </table>
    </div>
    <nav class="text-center" v-if="viewData && viewData.length !== 0">
      <Pagination
        :total-pages="totalPage"
        :total="-1"
        :per-page="-1"
        :current-page="currentPage"
        @pagechanged="onPageChange"
        @pageJump="onPageJump"
        :previousText="$t('navigation.bt.previous')"
        :nextText="$t('navigation.bt.next')"
        :firstText="$t('navigation.bt.first')"
        :lastText="$t('navigation.bt.last')"
      />
    </nav>
  </div>
</div>
</template>

<script>
    import Pagination from "@/components/base/Pagination";
    import PaginationMixin from "@/common/mixins/pagination"

    export default {
        components: {Pagination},
        mixins : [PaginationMixin],
        data() {
            return {
                PAGINATION_OFFSET: 10,
                errorMessage: null
            }
        },
        created() {
            this.initLoginHistory();
        },
        methods: {
            initLoginHistory() {
                let self = this;
                this.$service.getService(this.IConstants.HISTORY_ENUMS.HISTORY_SERVICE).getLoginHistory()
                    .then(response => {
                        if(response.data.errorMessage){
                            self.errorMessage = response.data.errorMessage
                        } else {
                            self.initPagination(response.data.amsCustomerSessionInfos, this.PAGINATION_OFFSET, 1);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
        }
    }
</script>

<style scoped>
  .w-12 {
    width: 12% !important;
  }
  .w-24 {
    width: 24% !important;
  }
  .w-16 {
    width: 16% !important;
  }
  tbody td {
    word-break: break-word;
  }

  @media (max-width: 767px) {
    .table-responsive .table tbody tr td,
    .table-responsive .table tbody tr th,
    .table-responsive .table thead tr td,
    .table-responsive .table thead tr th {
      white-space: nowrap
    }
  }
  
  /* fix missing border right on firefox */
  .border-right-1 {
    border-right: 1px solid #dee2e6 !important; 
  }
  
</style>
